import { render } from "./applyCouncil.vue?vue&type=template&id=466a4c6b&scoped=true"
import script from "./applyCouncil.vue?vue&type=script&lang=js"
export * from "./applyCouncil.vue?vue&type=script&lang=js"

import "./applyCouncil.vue?vue&type=style&index=0&id=466a4c6b&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-466a4c6b"]])

export default __exports__